import React from 'react';
import { useTranslation } from 'react-i18next';
import MessageModal from '@wix/da-ds/pkg/modals/dsPresets/MessageModal';
import { Warning } from '@wix/da-ds/pkg/Icons/Confirmations/Warning';
import { CancelButton } from '@wix/da-ds/pkg/modals/dsPresets/MessageModal/buttons';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';

import s from './CommunityChannelFullModal.scss';

export interface Props {
  requestClose: () => void;
}

const CommunityChannelFullModal: React.FC<Props> = ({ requestClose }) => {
  const { t } = useTranslation('damz');

  return (
    <MessageModal
      className={s['root']}
      isOpen
      variant="horizontal"
      image={<Warning />}
      onRequestClose={requestClose}
      title={t('damz.modal.communityChannelFullModal.title')}
      message={t('damz.modal.communityChannelFullModal.message')}
      footerButtons={[
        <CancelButton key="cancel" onClick={requestClose}>
          {t('damz.modal.communityChannelFullModal.cancel')}
        </CancelButton>,
        <BrandedButton
          key="confirm"
          size="large"
          variant="brand-green"
          onClick={requestClose}
        >
          {t('damz.modal.communityChannelFullModal.confirm')}
        </BrandedButton>,
      ]}
    />
  );
};

export default CommunityChannelFullModal;
